import { useNavigate } from "react-router-dom";
import { CalendarClock, Car, Phone, Wallet } from "lucide-react";
import { tr, useT } from "../../lib/i18n";
import { formatMoney } from "../../lib/settings";

const ICON = { drive: Car, inspection: Car, payment: Wallet, followup: Phone };

const fmtTime = (iso, lang) => {
  if (!iso) return tr("today.overdue");
  const d = new Date(iso.length === 10 ? `${iso}T09:00:00` : iso);
  return d.toLocaleTimeString(lang === "ar" ? "ar-OM-u-nu-latn" : "en-GB", { hour: "2-digit", minute: "2-digit" });
};

// Plain list sorted by time; one clear action per row.
export const TodayList = ({ items, settings, loading }) => {
  const nav = useNavigate();
  const { lang } = useT();
  if (loading) return <div className="grid gap-3">{[0, 1, 2].map((i) => <div key={i} className="ds-skeleton" style={{ height: 40 }} />)}</div>;
  if (!items.length) return <p className="text-sm py-6" style={{ color: "var(--ds-ink-muted)" }} data-testid="today-empty">{tr("today.empty")}</p>;
  return (
    <ul data-testid="today-list">
      {items.map((it) => {
        const Icon = ICON[it.kind] || CalendarClock;
        return (
          <li key={it.key} className="ds-row" data-testid={`today-row-${it.key}`}>
            <span className="num-display" style={{ width: 64, fontSize: 16, color: it.overdue ? "var(--ds-red)" : "var(--ds-ink)" }}>{fmtTime(it.at, lang)}</span>
            <Icon size={16} strokeWidth={1.75} aria-hidden="true" style={{ color: it.overdue ? "var(--ds-red)" : "var(--ds-ink-muted)" }} />
            <div className="min-w-0 flex-1">
              <div className="text-sm font-medium truncate">{tr(`today.k_${it.kind /* i18n-keys: drive,inspection,payment,followup */}`)}: {it.title}</div>
              {it.sub && <div className="text-xs truncate" style={{ color: "var(--ds-ink-muted)" }}>{it.sub}{it.amount != null ? ` · ${formatMoney(it.amount, settings)}` : ""}</div>}
            </div>
            <button className="btn-secondary text-xs" onClick={() => nav(it.to)} data-testid={`today-action-${it.key}`}>{tr(`today.a_${it.kind /* i18n-keys: drive,inspection,payment,followup */}`)}</button>
          </li>
        );
      })}
    </ul>
  );
};
